var transform = {
  serializeIn: function serializeIn(settings) {
    var _a;

    return {
      formatValue: typeof ((_a = settings === null || settings === void 0 ? void 0 : settings.tooltipSettings) === null || _a === void 0 ? void 0 : _a.formatValue) === 'string' ? settings.tooltipSettings.formatValue : null
    };
  },
  serializeOut: function serializeOut(_ref) {
    var formatValue = _ref.formatValue;
    return {
      tooltipSettings: {
        formatValue: formatValue
      }
    };
  }
};
export default transform;